import React from 'react'
import Dashboard from '../components/dashboard/Dashboard'

const DashboardMainPage = () => {
  return (
    <div>
       <Dashboard/>
    </div>
  )
}

export default DashboardMainPage
